module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_03-3617cdd8da6fe3c57c87ba2006418729.jpg";